
import React from "react";
import AutoBindComponent from "../common/AutoBindComponent";
import { bindActionCreators } from "redux";

import SimulatieResultaatForm from "./SimulatieResultaatForm";
import SimulatieResultaatPageHelper from "./SimulatieResultaatPageHelper";
import * as simulatieDossierActions from "../../actions/simulatieDossierActions";
import * as domainConstants from "../../constants/DomainConstants";
import mergeDeep from "../../util/mergeDeep.js";
import * as types from "../../constants/ComponentConstants";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import redirector from "../../util/redirector.js";
import showToastr, { showToastrInfo, showToastrError, showToastrSuccess } from "../../util/toastr.js";

import * as documentActions from "../../actions/documentActions";

class SimulatieResultaatPage extends AutoBindComponent {
    constructor(props) {
        super(props);

        this.state = {
            fileSessionStarted: false,
            hasUnsavedChanges: false,
            pdf: {},
            pdfGegenereerdOp: null
        };

        this.pageHelper = new SimulatieResultaatPageHelper(this, redirector);
    }

    componentWillMount() {
        this.pageHelper.init();

        let simulatieDossierId = this.props.simulatieDossierId;
        if (simulatieDossierId) {
            this.props.getContent(simulatieDossierId, domainConstants.DocumentTab.Simulatiedossier)
                .then(result => {
                    if (result.success) {
                        const pdfFiles = result.data.length > 0 && result.data[0].files.length > 0 ? result.data[0] : null;
                        if (pdfFiles) {
                            this.setState(
                                {
                                    pdf: pdfFiles
                                });
                        }
                    } else {
                        showToastrError("Laden van het dossier is mislukt");
                        throw new Error("getContent load failed"); //Stops promise
                    }
                });
        }
    }

    componentWillUnmount() {
        this.handleOnStopInterval();
    }

    componentWillReceiveProps(nextProps) {
    }

    handleOnWijzig(event) {
        this.pageHelper.wijzig();
    }

    handleOnStartDossier() {
        this.pageHelper.startDossier();
    }

    handleOnStartInterval() {
        this.setState({ pollCount: 0 });
        const timer = setInterval(() => {
            if (this.state.pollCount > 19) {
                this.handleOnStopInterval();
            }
            this.props.getContent(this.props.simulatieDossierId, "dossierPDF")
                .then(result => {
                    if (result.success) {
                        const hasPdfFiles = result.data.length > 0 && result.data[0].files.length > 0 ? result.data[0] : null;
                        const pdfFiles = result.data.length > 0 ? result.data[0] : null;

                        if (hasPdfFiles) {
                            this.pageHelper.getSimulatieDossier(this.props.simulatieDossierId);
                            this.handleOnStopInterval();
                        }

                        this.setState(
                            {
                                pdf: pdfFiles
                            });
                    }
                    this.setState({ pollCount: this.state.pollCount + 1 });
                });
        }, 10000);

        this.setState({ timer: timer });
    }

    handleOnStopInterval() {
        clearInterval(this.state.timer);
        this.setState({ timer: null });
    }

    handleOnGenerateRapport() {
        this.setState({ pdfGegenereerdOp: null });
        this.props.generateRapportSimulatieDossier(this.props.simulatieDossierId).then(result => {
            if (result) {
                let sim = mergeDeep({}, this.state.simulatieDossier, { dossierPDFGegenereerd: false });
                this.setState({
                    simulatieDossier: sim,
                    pdfGegenereerdOp: result
                });
                showToastr(domainConstants.PDF_SIMULATIE_GENEREREN);
                this.handleOnStartInterval();
            }
        });
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        const bovenLokaliteitPerInfrastructuur = this.state.simulatieDossier.bovenlokaliteitHoogsteScore;
        const gewichten = this.state.gewichten;

        const ruimteScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.ruimteScoreOpTien : null;
        const milieuEnHinderScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.milieuEnHinderScoreOpTien : null;
        const clusterInAantalScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.clusterInAantalScoreOpTien : null;
        const clusterInTypeScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.clusterInTypeScoreOpTien : null;
        const uniciteitScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.uniciteitScoreOpTien : null;
        const afstandScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.afstandScoreOpTien : null;
        const topsportGelegenheidScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.topsportGelegenheidScoreOpTien : null;
        const slaapgelegenheidScoreOpTien = bovenLokaliteitPerInfrastructuur !== null ? bovenLokaliteitPerInfrastructuur.slaapgelegenheidScoreOpTien : null;

        const simulatieDossierFormProps = {
            simulatieDossier: this.state.simulatieDossier,
            disabled: this.props.disabled,
            color: types.COLOR_BLUE,
            scores: [{ omschrijving: "Ruimte en landschapsimpact", score: ruimteScoreOpTien, punten: gewichten.ruimtePunten, wegingsfactor: gewichten.ruimteGewicht },
            { omschrijving: "Milieu en hinder", score: milieuEnHinderScoreOpTien, punten: gewichten.hinderPunten, wegingsfactor: gewichten.hinderGewicht },
            { omschrijving: "Cluster in aantal", score: clusterInAantalScoreOpTien, punten: gewichten.clusterAPunten, wegingsfactor: gewichten.clusterAGewicht },
            { omschrijving: "Cluster in type", score: clusterInTypeScoreOpTien, punten: gewichten.clusterBPunten, wegingsfactor: gewichten.clusterBGewicht },
            { omschrijving: "Uniciteit", score: uniciteitScoreOpTien, punten: gewichten.uniciteitPunten, wegingsfactor: gewichten.uniciteitGewicht },
            { omschrijving: "Afstand", score: afstandScoreOpTien, punten: gewichten.afstandPunten, wegingsfactor: gewichten.afstandGewicht },
            { omschrijving: "Topsportgelegenheid", score: topsportGelegenheidScoreOpTien, punten: gewichten.topsportPunten, wegingsfactor: gewichten.topsportGewicht },
            { omschrijving: "Slaapgelegenheid", score: slaapgelegenheidScoreOpTien, punten: gewichten.slaapaccommodatiePunten, wegingsfactor: gewichten.slaapaccommodatieGewicht }],
            onWijzig: this.handleOnWijzig,
            totaalGewicht: gewichten.totaalGewicht,
            totaalPunten: gewichten.totaalPunten,
            onStartDossier: this.handleOnStartDossier,

            pdf: this.state.pdf,
            fileSessionStarted: this.state.fileSessionStarted,
            onGenerateRapport: this.handleOnGenerateRapport,
            isPollingDocument: this.state.timer ? true : false,
            hasUnsavedChanges: this.state.hasUnsavedChanges,
            pdfGegenereerdOp: this.state.pdfGegenereerdOp
        };
        return (<SimulatieResultaatForm {...simulatieDossierFormProps} />);
    }
}

SimulatieResultaatPage.propTypes = {
    disabled: PropTypes.bool,
    loadLayout: PropTypes.func.isRequired,
    simulatieDossierId: PropTypes.string,
    getContent: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
    const simulatieDossierId = ownProps.params.simulatieDossierId;
    const disabled = state.ajaxCounter > 0;

    return {
        disabled: disabled,
        simulatieDossierId: simulatieDossierId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        generateRapportSimulatieDossier: bindActionCreators(simulatieDossierActions.generateRapportSimulatieDossier, dispatch),
        getContent: bindActionCreators(documentActions.getContent, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(SimulatieResultaatPage));